module.exports = __webpack_public_path__ + "img/IDEX.b8600808.png";